module.exports = __webpack_public_path__ + "static/media/8.Petrol Lawnmower.fae0ac38.jpg";